export class loginModel {
    emailId!: string;
    password!: string;
}

export class verificationCodeModel{
    EmailId!: string;
    Otp!: string;
    EncryptedOtp!:string
    IsLoginProtection!: boolean
    CityName!: string;
    StateName!: string;
    CountryName!: string;
    PostalCode!: string;
    CountryCapital!: string;
    iPAddress!: string;
    iPVersion!: string;
    network!: string;
    org!: string;
}